// Definicao da PRIMEIRA senha, para conta criada por importacao em lote.
// Mesma mecanica do RedefinePassword (mesmo token de reset, mesmo endpoint): o que
// muda e o texto. Quem cai aqui nao pediu para redefinir nada -- acabou de ter a
// conta criada por migracao e ainda nem sabe que virou usuario da plataforma.
// Reusa o CSS do redefinePassword de proposito, para as duas telas nao divergirem.
import '../redefinePassword/RedefinePassword.css';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validatePassword } from '../../utils/format';
import Button from '../../components/button/Button';
import Input from '../../components/input/Input';

import welcomePasswordIcon from '../../assets/check_circle.svg';
import { resetPassword } from '../../services/userService';

import { useBrandContext } from '../../context/BrandContext';

const WelcomePassword = () => {
    type Inputs = { newPassword: string, confirmPassword: string };
    type Touched = Partial<Record<keyof Inputs, boolean>>;
    type Errors = Partial<Record<keyof Inputs, string>>;

    const [form, setForm] = useState<Inputs>({ newPassword: '', confirmPassword: '' });
    const [touched, setTouched] = useState<Touched>({});
    const [errorsValidate, setErrorsValidate] = useState<Errors>({});
    const [errorFetch, setErrorFetch] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    const { token } = useParams();

    const brandContext = useBrandContext();

    const validate = (newInputs: Inputs): Errors => {
        let newErrors: Errors = {};
        if (!form.newPassword.trim()) {
            newErrors.newPassword = "Campo Obrigatório";
        } else if (!validatePassword(newInputs.newPassword)) {
            newErrors.newPassword = "A senha precisa ter pelo menos 6 caracteres. Por favor, tente novamente.";
        }

        if (!form.confirmPassword.trim()) {
            newErrors.confirmPassword = "Campo Obrigatório";
        } else if (!validatePassword(newInputs.confirmPassword)) {
            newErrors.confirmPassword = "A senha precisa ter pelo menos 6 caracteres. Por favor, tente novamente.";
        } else if (newInputs.confirmPassword !== newInputs.newPassword) {
            newErrors.confirmPassword = "A confirmação de senha deve ser igual à senha";
        }

        setErrorsValidate(newErrors);
        return newErrors;
    };

    const handleKeyPress = (event: any) => {
        if (event.key === ' ') {
            event.preventDefault();
        }
    };

    const handleShowNewPassword = () => setShowNewPassword(showNewPassword => !showNewPassword);
    const handleShowConfirmNewPassword = () => setShowConfirmPassword(showConfirmPassword => !showConfirmPassword);

    const handleSubmit = async (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        const errors = validate(form);
        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            const payload = { password: form.newPassword, token };
            try {
                const response = await resetPassword(payload);
                if (response.status === 200) {
                    navigate(`/${brandContext.brandName}/sucessWelcomePassword`);
                }
                setIsLoading(false);
                setErrorFetch('');
            } catch (error: any) {
                setIsLoading(false);
                if (error?.message === 'Network Error') {
                    setErrorFetch('Sua conexão está instável. Por favor, tente mais tarde.');
                } else {
                    setErrorFetch('Falha no servidor. Por favor tente novamente.');
                }
            }
        }
    };

    return (
        <div className='redefine-password-wrapper'>
            <div className="redefine-password-container">
                <form onSubmit={handleSubmit} className="redefine-password-form">
                    <div className='redefine-password-fields'>
                        <span className='redefine-password-title'>Crie sua senha</span>
                        <span className='password-requirements'>
                            Sua conta já está pronta. Defina uma senha para acessar o app.
                        </span>

                        <Input
                            htmlFor='newPassword'
                            type={showNewPassword ? "text" : "password"}
                            id='newPassword'
                            labelName='Senha'
                            className={errorsValidate.newPassword ? "input-pattern error-input" : "input-pattern"}
                            placeholder="Sua senha"
                            value={form.newPassword}
                            onKeyDown={event => handleKeyPress(event)}
                            onChange={event => setForm({ ...form, newPassword: event.target.value })}
                            onBlur={() => setTouched({ ...touched, newPassword: true })}
                            isErrorValidate={errorsValidate.newPassword ? true : false}
                            isPassword={true}
                            handleShowPassword={handleShowNewPassword}
                            showPassword={showNewPassword}
                            messageError={errorsValidate.newPassword}
                            style={{ flexGrow: 1, marginRight: '-19px' }}
                        />

                        <Input
                            htmlFor='confirmPassword'
                            type={showConfirmPassword ? "text" : "password"}
                            id='confirmPassword'
                            labelName='Confirme a senha'
                            className={errorsValidate.confirmPassword ? "input-pattern error-input" : "input-pattern"}
                            placeholder="Confirme sua senha"
                            value={form.confirmPassword}
                            onKeyDown={event => handleKeyPress(event)}
                            onChange={event => setForm({ ...form, confirmPassword: event.target.value })}
                            onBlur={() => setTouched({ ...touched, confirmPassword: true })}
                            isErrorValidate={errorsValidate.confirmPassword ? true : false}
                            isPassword={true}
                            handleShowPassword={handleShowConfirmNewPassword}
                            showPassword={showConfirmPassword}
                            messageError={errorsValidate.confirmPassword}
                            style={{ flexGrow: 1, marginRight: '-19px' }}
                        />

                        <b className='error-fetch-redefine-password'>{errorFetch ? errorFetch : null}</b>
                        <Button
                            style={{ backgroundColor: brandContext.brandBgColor ? brandContext.brandBgColor : '#3CCC10', color: '#FFFFFF', marginTop: '33px' }}
                            type='submit'
                            children="Criar senha"
                            image={<img alt='welcome-password-icon' src={welcomePasswordIcon} />}
                            loading={isLoading}
                            disabled={isLoading}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default WelcomePassword;
